export default __webpack_public_path__ + "static/static-banner-1-f459dddaa563fe4daed4d234a231a414.jpg";